export class ProcessSummary {
  
    public name: string;
    public key: string;
    public submitted = 0;
    public inProgress= 0;
    public total = 0;
  }  